/* eslint-disable */
export default {
    xsBreakpoint: 575,
    smBreakpoint: 768,
    mdBreakpoint: 948,
    lgBreakpoint: 1171,
    fullBreakpoint: 1330,

    mobileHelper() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },

    /**
     * return true, if screen is smaller than x
     * @param brekpoint
     * @returns {boolean}
     */
    smallScreenHelper(brekpoint) {
        return $(window).width() <= brekpoint;
    },

    /**
     *
     * @param target
     * @param topPosition
     * @returns {boolean}
     */
    smoothScroll(target, topPosition = 100) {
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top - topPosition
            }, 500);
        }
    },
    /**
     * Check this-target is on the same page.
     * @param element
     * @returns {boolean|boolean}
     */
    checkLocation(element) {
        return (element.pathname && location.pathname.replace(/\/+$/, '') === element.pathname.replace(/\/+$/, '')) && (element.hostname && location.hostname.replace(/\/+$/, '') === element.hostname.replace(/\/+$/, ''));
    },

    replaceChars($text) {
        return $text.replace(/([^A-Za-z0-9])/g, '');
    },

    /**
     * @param name
     * @param value
     * @param days
     */
    setCookie(name, value, days, hours = false) {
        var expires = "";
        if (days) {
            var date = new Date();
            if (hours) {
                date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
            } else {
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            }
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax; Cache-Control=no-cache, no-store, must-revalidate;";
    },

    /**
     * @param name
     * @returns {string|null}
     */
    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },

    /**
     * @param name
     */
    deleteCookie(name) {
        setCookie(name, '', -1);
    }
}



// WEBPACK FOOTER //
// ./scripts/util/Helper.js